import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Home from './pages/home';
import Year2026 from './pages/Year2026';
import Year2025 from './pages/Year2025';
import Year2024 from './pages/Year2024';
import Year2023 from './pages/Year2023';
import Year2022 from './pages/Year2022';
import Year2021 from './pages/Year2021';
import Year2020 from './pages/Year2020';
import Year2019 from './pages/Year2019';
import Year2018 from './pages/Year2018';
import Year2017 from './pages/Year2017';
import Year2016 from './pages/Year2016';
import Year2015 from './pages/Year2015';
import Gibraltar from './pages/gibraltar';
import Uganda from './pages/uganda';
import Kyrgyzstan from './pages/kyrgyzstan';
import Georgia from './pages/georgia';
import Luxembourg from './pages/luxembourg';
import Israel from './pages/israel';
import Montenegro from './pages/montenegro';
import Ireland from './pages/ireland';
import Albania from './pages/albania';
import Mexico from './pages/mexico';
import Bornholm from './pages/bornholm';
import Croatia from './pages/croatia';
import Bali from './pages/bali';
import Slovenia from './pages/slovenia';
import Lithuania from './pages/lithuania';
import Jordan from './pages/jordan';
import Norway from './pages/norway';
import CostaRica from './pages/costarica';
import SriLanka from './pages/srilanka';
import CapeVerde from './pages/capeverde';
import Latvia from './pages/latvia';
import Vietnam from './pages/vietnam';
import Switzerland from './pages/switzerland';
import CountriesVisited from './pages/countriesvisited';
import NextDestination from './pages/nextdestination';
import Norwayy from './pages/norwayy';
import Bosnia from './pages/bosnia';
import Svalbard from './pages/svalbard';


function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/2026" element={<Year2026 />} />
          <Route path="/2025" element={<Year2025 />} />
          <Route path="/2024" element={<Year2024 />} />
          <Route path="/2023" element={<Year2023 />} />
          <Route path="/2022" element={<Year2022 />} />
          <Route path="/2021" element={<Year2021 />} />
          <Route path="/2020" element={<Year2020 />} />
          <Route path="/2019" element={<Year2019 />} />
          <Route path="/2018" element={<Year2018 />} />
          <Route path="/2017" element={<Year2017 />} />
          <Route path="/2016" element={<Year2016 />} />
          <Route path="/2015" element={<Year2015 />} />
          <Route path="/gibraltar" element={<Gibraltar />} />
          <Route path="/uganda" element={<Uganda />} />
          <Route path="/kyrgyzstan" element={<Kyrgyzstan />} />
          <Route path="/georgia" element={<Georgia />} />
          <Route path="/luxembourg" element={<Luxembourg />} />
          <Route path="/israel" element={<Israel />} />
          <Route path="/montenegro" element={<Montenegro />} />
          <Route path="/ireland" element={<Ireland />} />
          <Route path="/albania" element={<Albania />} />
          <Route path="/mexico" element={<Mexico />} />
          <Route path="/bornholm" element={<Bornholm />} />
          <Route path="/croatia" element={<Croatia />} />
          <Route path="/bali" element={<Bali />} />
          <Route path="/slovenia" element={<Slovenia />} />
          <Route path="/lithuania" element={<Lithuania />} />
          <Route path="/jordan" element={<Jordan />} />
          <Route path="/norway" element={<Norway />} />
          <Route path="/costarica" element={<CostaRica />} />
          <Route path="/srilanka" element={<SriLanka />} />
          <Route path="/capeverde" element={<CapeVerde />} />
          <Route path="/latvia" element={<Latvia />} />
          <Route path="/vietnam" element={<Vietnam />} />
          <Route path="/switzerland" element={<Switzerland />} />
          <Route path= "/norwayy" element={<Norwayy />} />
          <Route path= "/bosnia" element={<Bosnia />} />
            <Route path= "/svalbard" element={<Svalbard />} />
          <Route path="/countries-visited" element={<CountriesVisited />} />
          <Route path="/next-destination" element={<NextDestination />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;